'use client';

import styled from 'styled-components';

import { colors } from '@/styles/theme';

export const Container = styled.button`
  position: relative;

  padding: 12px 32px;

  font-weight: 600;
  overflow: hidden;
  color: ${colors.light};
  background: linear-gradient(to bottom right, ${colors.purple}, ${colors.aqua});
  border: none;
  border-radius: 8px;
  transition: all 0.3s ease-out;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  &:hover {
    cursor: pointer;
    transform: scale(1.05);
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const Content = styled.span`
  position: relative;
  z-index: 10;
`;

export const HoverBackground = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  background: linear-gradient(to bottom right, ${colors.aqua}, ${colors.purple});
  opacity: ${(props) => (props.$visible ? 1 : 0)};
  transition: opacity 0.3s ease-out;
`;
